import { render, staticRenderFns } from "./BankAccountForm.vue?vue&type=template&id=05f16b9a&scoped=true&"
import script from "./BankAccountForm.vue?vue&type=script&lang=js&"
export * from "./BankAccountForm.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountForm.vue?vue&type=style&index=0&id=05f16b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f16b9a",
  null
  
)

export default component.exports